
// @flow

import get from 'lodash/get'

export const documentsSelector = (state: Object) => Object.values(get(state, 'document.data'))
